<template>
  <el-dialog
    v-if="dialogVisible"
    v-model="dialogVisible"
    :title="title"
    :width="width"
    :center="dialogCenter"
    :align-center="dialogCenter"
    :destroy-on-close="destroyOnClose"
  >
    <div :class="{'date-picker-container': contentCenter}">
      <!-- 内容插槽 -->
      <slot />
    </div>
    <template
      #footer
      v-if="showFooter"
    >
      <el-button @click="closeDialog">
        {{ t(cancelText) }}
      </el-button>
      <el-button
        type="primary"
        @click="confirmDialog"
      >
        {{ t(confirmText) }}
      </el-button>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import { handleClipboard } from '@/utils/clipboard'

export default defineComponent({
  name: 'BaseDialog',
  methods: { handleClipboard },
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    contentCenter: {
      type: Boolean,
      default: false
    },
    dialogCenter: {
      type: Boolean,
      default: false
    },
    destroyOnClose: {
      type: Boolean,
      default: false
    },
    width: {
      type: String,
      default: '50%'
    },
    confirmText: {
      type: String,
      default: 'message.confirm'
    },
    cancelText: {
      type: String,
      default: 'message.cancel'
    },
    autoClose: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue', 'confirm', 'close'],
  setup(props, context) {
    const { t } = useI18n()
    // 使用 computed 实现双向绑定
    const dialogVisible = computed({
      get: () => props.modelValue,
      set: (value) => context.emit('update:modelValue', value)
    })
    const confirmDialog = async() => {
      if (props.autoClose) {
        context.emit('confirm') // 先触发回调
        dialogVisible.value = false
      } else {
        context.emit('confirm') // 先触发回调,然后由父组件关闭
      }
    }
    const closeDialog = () => {
      context.emit('close') // 先触发回调
      dialogVisible.value = false // 再自动关闭
    }
    return {
      t,
      dialogVisible,
      confirmDialog,
      closeDialog
    }
  }
})
</script>

<style
  scoped
  lang="scss"
>
.date-picker-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
